import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,Timer,AudioLines,
  FolderHeart, Forward,Earth,ListChecks,Gift,Settings,BetweenHorizontalStart,
  ImagePlay,Film,AlarmSmoke,BellElectric,CircleCheck,LayoutGrid ,CornerDownRight,BotMessageSquare,ChevronUp,ChevronDown,
  GripHorizontal,
  CopyPlus,
  Bookmark,
  Pencil,
  Trash2,
  Recycle,
  Play,
  ChevronLeft,
  ChevronRight} from 'lucide-react';import Snackbar from "../../../../Snackbar";
import CreateSubCoursePopUp from "./CreateSubCoursePopUp";
import ContentFolderCard from "../ContentFolderCard";
import { getAllMilestonesBySubCourseId, getAllSubCoursesByCourseId, reArrangeSubCourses } from "../../../../store/actions/CreateContent/OrganizeAPI/SubCoursesAPIs";
import FolderFilterCardTwo from "../FolderFilterCardTwo";
import FolderFilterCardThree from "../FolderFilterCardTwoThree";
import FolderFilterCard from "../FolderFilterCard";
import AddToFolderButton from "../AddToFolderButton";
import CreateMileStonePopup from "./CreateMileStonePopUp";
import LoadingButton from "../../../Loading/LoadingButton";
import SectionFolderPanel from "./SectionFolderPanel";

const MilestonePanel =({selectCoursePopUp,SubCourseData,setOpenMilestoneForSubCourse,setCreateNewMileStone})=>{

     const dispatch = useDispatch();
         const user = useSelector((state)=>state?.user?.user);
               const [activeFilterOne, setActiveFilterOne] =useState(true);
                       const [activeFilterTwo, setActiveFilterTwo] =useState(true);
                       const [activeFilterThree, setActiveFilterThree] =useState(false);
                       const [activeFilterFour, setActiveFilterFour] =useState(false);
                       const [activeFilterASC, setActiveFilterASC] =useState(true);
                       const [activeFilterDESC, setActiveFilterDESC] =useState(false);
                       const [createNewMileStoneStatus, setCreateNewMileStoneStatus] =useState(setCreateNewMileStone?true:false);
                       
         const [snackbarVisible, setSnackbarVisible] = useState(false);
                          const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                          const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                    
                                  const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
                       const showSnackbar = () => {
                         setSnackbarVisible(true);
                       };
                      
                       const hideSnackbar = () => {
                         setSnackbarVisible(false);
                       };
                 
                 
                            
                            
                         
                        const [animate, setAnimate] = useState(false);
          
           const [loader , setLoader] =useState({status:true});
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
      const [openAppDesignPopUp,setopenAppDesignPopUp]  = useState(false);
      const [openAppDesignPopUpInnerContent,setopenAppDesignPopUpInnerContent]  = useState("appThemes");

      
const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
     
             const appId = useSelector((state)=>state?.app?.app?.ID);
             const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
               
            
      const scrollRef = useRef(null);
           const [visibility,setVisibility] =useState("public");
           const [orderBy,setOrderBy] =useState("ASC");
           const [itemArr, setItemArr] = useState([]);
           const [itemReorderArr, setItemReorderArr] = useState([]);
           const [itemId, setItemId] = useState("");
           const [deleteSubCoursePopUp, setDeleteSubCoursePopUp] = useState(false);
           const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{},{}]);
           const [openContentInFolder, setOpenContentInFolder] = useState("");
           
 const [subCourseItem ,setSubCourseItem] =useState({});
 const [mileStoneItem ,setMileStoneItem] =useState({});
 const [mileStoneSection ,setMileStoneSection] =useState({});
 const [sectionName ,setSectionName] =useState("");
 const [newSectionPopUp ,setNewSectionPopUp] =useState(false);
 
 const updateItemData = (ID, newData) => {


  setMileStoneSection(newData);
  const updatedItems = itemArr.map(item =>
    item?.ID === ID ? { ...item, Description :newData?.Description
        , 
    } : item
  
  ); 

 // console.log(updatedItems)
  setItemArr(updatedItems);
};
const sendBackItem = (mileStone) => {

  // console.log(mileStone)
  setMileStoneSection(mileStone);setCreateNewMileStoneStatus(false);
  const updatedItems = [...itemArr, mileStone]
  const updatedItemsMenuorder = [...itemReorderArr, {ID:mileStone?.ID,menuOrder:mileStone?.menuOrder}]
  setItemReorderArr( updatedItemsMenuorder);
 // console.log(updatedItems)
  setItemArr(updatedItems);
};




useEffect(() => {
  if (scrollRef.current) {
    scrollRef.current.scrollTo({
      top: scrollRef.current.scrollHeight,
      behavior: "smooth",
    });
  }
}, [mileStoneSection]);


      useEffect((e)=>{
      
        fireGetAllMilestonesBySubCourseId();
        },[visibility,postIdCourse]);
  const fireGetAllMilestonesBySubCourseId=()=>{
          setItemArr([])
         
        
          setItemArrLoading([{},{},{},{},{}])
        // Popup When Course is not selected
          if(courseData){}else{selectCoursePopUp(true);}
        
        setLoader({status:true});
            // console.log({
            //     token:AppToken,courseId:postIdCourse ,postParent:SubCourseData?.ID,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
            //     appToken:AppToken,visibility:visibility,orderBy:orderBy
            //     });
              const apiData = dispatch(getAllMilestonesBySubCourseId({
                token:AppToken,courseId:postIdCourse ,postParent:SubCourseData?.ID,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
                appToken:AppToken,visibility:visibility,orderBy:orderBy,appId:appId,appAllottedToken:appAllottedToken
                }));
              /* get response as Promise   */
              apiData.then(response => {
                // console.log(response)
        
                if(response){
                 
                  if(response){
                setResponseMessage(response?.message);
                setSnackbarColor("rgba(144, 202, 249,1)");
              
                if(response?.mileStones)  {setItemArr(response?.mileStones); 
                  
                  if(!createNewMileStoneStatus){setMileStoneSection(response?.mileStones[0])}
                  if(createNewMileStoneStatus){setVisibility('public');setMileStoneItem(null); setopenAppDesignPopUp(true);setopenAppDesignPopUpInnerContent("createMileStone");}
      
                  const reorderArray = response?.mileStones.map(item => ({
                    ID: item.ID,
                    menuOrder: item.menuOrder
                }));
                setItemReorderArr(reorderArray);
                //  console.log(reorderArray)
               
                }else{setItemArr([]);};
                setItemArrLoading([]);
            setLoader({status:false});
            
            // setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
            },1000)
               }else{
            //     setResponseMessage("Something Went Wrong...");
                  
            //     setSnackbarColor("#958FDA");
            //   //  selectCoursePopUp(true);
                
                 
            // setLoader({status:false});
            // setItemArrLoading([{},{},{},{},{}]);
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
               }
                  
                // dispatch({
                //   type: "UPDATE_APP_TOKEN",
                  
                //   payload:response?.course?.AppToken
                // });  
              //  console.log(response?.course);
             
               // 
               if(response?.logout){
                // pop up response?.logoutInfo
                //console.log(response?.logoutInfo)
            
                setResponseMessage("You are Logged Out!!!");
                  
                setSnackbarColor("#958FDA");
               selectCoursePopUp(true);
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                setTimeout(()=>{
                  dispatch({type:"LOGOUT"});
            
                },3000)
                
              }
            /* resetting Login input Fields */
            
                }else{
                  setResponseMessage("Something Went Wrong...");
                  
                  setSnackbarColor("#958FDA");
                 selectCoursePopUp(true);
                 setItemArrLoading([{},{},{},{},{}]);
                   
              setLoader({status:false});
              
              setSnackbarVisible(true);
              setTimeout(()=>{
                
                setSnackbarVisible(false);
               
                 
              },3000)    }
            
              }).catch(error => {
             
                //popup of error Info
                setResponseMessage("Something Went Wrong...");
                  
                setSnackbarColor("#958FDA");
               selectCoursePopUp(true);
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                console.error(error);
              });
         }

         const flattenedData = itemArr!=[]?Object.values(itemArr):'';

         const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';
 

 const HorizontalScroller = ({ items }) => {
    const scrollerRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
  
    const scroll = (direction) => {
      if (scrollerRef.current) {
        const scrollAmount = 260; // Adjust scroll distance per click
        scrollerRef.current.scrollBy({
          left: direction === "left" ? -scrollAmount : scrollAmount,
          behavior: "smooth",
        });
      }
    };
     // Mouse drag handlers
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollerRef.current.offsetLeft);
    setScrollLeft(scrollerRef.current.scrollLeft);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault(); // Prevent text selection
    const x = e.pageX - scrollerRef.current.offsetLeft;
    const walk = (x - startX) * 2; // Adjust for sensitivity
    scrollerRef.current.scrollLeft = scrollLeft - walk;
  };


  const handleMouseUp = () => setIsDragging(false);
  const handleMouseLeave = () => setIsDragging(false);

    return (
      <div className="scroller-wrapper">
        <button className="scroll-btn left" onClick={() => scroll("left")}>
          <ChevronLeft   onMouseEnter={handleMouseEnter}
                             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={30} 
                   color="#ffffff" />
        </button>
        <div className="scroller" ref={scrollerRef} >
          {items.map((item, index) => (
            <div key={index} style={{display:"flex",justifyContent:"flex-start", }} onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseLeave}   >
       
            <div
className={"posRelative scroller-item"  }
             style={{ margin:"0px",marginTop:"-5px",background:mileStoneSection?.menuOrder==item?.menuOrder?"rgba(144, 202, 249,0.4) ":"rgba(144, 202, 249,0.1) ",
                marginRight:"0px",position:"relative",borderRadius:"10px",overflow:"hidden"}} 
          
             
            >  <div  style={{display:"flex",justifyContent:"space-between" }}>
          <div  className="">
                     </div> <div   style={{width:"155px",marginTop:"0px",fontWeight:"999"}}  >
                   <div  className="TitleWithEllipsis" style={{width:"150px",marginTop:"10px",fontWeight:"999"}}  >
                  MileStone {item?.menuOrder}  
                   </div> 
                   <div align="center" className="" style={{marginTop:"20px",marginLeft:"30px"}} ><div   onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave}
                    style={{cursor:"pointer",color:"rgba(144, 202, 249,1)",left:"50px",background:"#fff",width:"120px",fontSize:"14px",height:"40px"}} 
           onClick={()=>{ setMileStoneSection(item);setCreateNewMileStoneStatus(false);}}   className="milestoneButtonInCard" >Add Content </div>
           </div>
                     </div>
                    <div   
                  className="">
                     <div   
                  className="">
                   {visibility=="public"?<Pencil  onClick={()=>{setVisibility('public');setActiveFilterTwo(true);;setActiveFilterThree(false);setActiveFilterFour(false); 
                   setMileStoneItem(item);setMileStoneSection(item);setCreateNewMileStoneStatus(false); setopenAppDesignPopUp(true);setOpenContentInFolder("");setopenAppDesignPopUpInnerContent("createMileStone");}}
                    onMouseEnter={handleMouseEnter}
                              onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
                   color="#666666" style={{padding:"10px",border:"2px solid #ffffff",background:"#fafafa",margin:"5px",borderRadius:"5px",cursor:"pointer",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0381)"}}/>
                 :<div></div> }
                 
                 </div> 
                  {/* <div   
                  className=""> <Trash2 onClick={()=>{}}
                   onMouseEnter={handleMouseEnter}
                             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
                   color="#666666" style={{padding:"10px",border:"2px solid #ffffff",background:"#fafafa",margin:"5px",borderRadius:"5px",cursor:"pointer",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0381)"}}/> 
                   
                   </div> */}
                   </div>
                   </div>     
                   </div>  
            </div>
          ))}


{flattenedDataLoading?flattenedDataLoading?.map((item, index) => (
  <div key={index} style={{display:"flex",justifyContent:"flex-start", }}    >
       
            <div
className={"scroller-item text-linetw"  }
             style={{ margin:"0px",marginTop:"-5px",
                marginRight:"0px",position:"relative",borderRadius:"10px",overflow:"hidden"}} 
          
             
            >  <div  style={{display:"flex",justifyContent:"space-between" }}>
          <div  className="">
                     </div> <div   style={{width:"155px",marginTop:"0px",fontWeight:"999"}}  >
                   <div  className="TitleWithEllipsis" style={{width:"150px",marginTop:"10px",fontWeight:"999"}}  >
                 
                   </div>  </div>  </div>  </div>  </div> )):""} 
      
          {!flattenedDataLoading?.length?<div  
className={" scroller-item"  }
             style={{ margin:"0px",marginTop:"-5px",background:" rgba(144, 202, 249,0.1) ",
                marginRight:"0px",position:"relative",borderRadius:"10px",overflow:"hidden"}} 
          
              >
                      <div   style={{width:"155px",marginTop:"0px",fontWeight:"999"}}  >
                   <div  className="TitleWithEllipsis" style={{width:"150px",marginTop:"10px",fontWeight:"999"}}  >
                   
                   </div> 
                   <div align="center" className="" style={{marginTop:"20px",marginLeft:"60px"}} ><div   onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} style={{cursor:"pointer",color:"rgba(144, 202, 249,1)",left:"70px",background:"#fff"}} 
           onClick={()=>{setVisibility('public');setCreateNewMileStoneStatus(true); setMileStoneItem(null); setopenAppDesignPopUp(true);setopenAppDesignPopUpInnerContent("createMileStone");}}  className="milestoneButtonInCard"><Plus strokeWidth={3} absoluteStroeWidth color="rgba(144, 202, 249,1)"  size={38} /> </div>
           </div>
                     </div>
                    <div   
                  className="">
                     <div   
                  className="">
                   
                 </div>  <div   
                  className=""> 
                   </div>
                   </div>
                   </div>  :""}   
                   
        </div>
        <button className="scroll-btn right" onClick={() => scroll("right")}>
        <ChevronRight   onMouseEnter={handleMouseEnter}
                             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={30} 
                   color="#ffffff" />
        </button>
      </div>
    );
  };

  
    return (<>
        {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}
        <div  align="left" className="contentPageScroller" ref={scrollRef} > <div style={{margin:"5px"}} >
        <div className="bgGradientSubCourse" style={{padding:"15px",paddingBottom:"0px",borderRadius:"5px"}}> 
          <div align="left" > <div   onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} style={{cursor:"pointer",left:"-10px",float:"left",width:"30px",position:"relative",zIndex:"9"}} 
                   onClick={()=>{setOpenMilestoneForSubCourse("")}} 
                     className="">
                        <ChevronLeft strokeWidth={3}  size={30}    color="#fff"  /></div>
        
        </div>   
         <h2 className="ellipsisTitleSubCourse" style={{color:"#fff",left:"10px",position:"relative",top:"-19px"}}> Sub-course {SubCourseData?.menuOrder} :  {SubCourseData?.Name}</h2>
            <h5  className="ellipsisSubTitleSubCourse"style={{color:"#fff",position:"relative",top:"-19px"}}>{SubCourseData?.Description}</h5>
           
            <div className="" style={{padding:"5px",display:"flex",justifyContent:"flex-start",position:"relative",top:"-25px"}}> 
            <div className="" style={{padding:"5px",display:"flex",justifyContent:"flex-start"}}> 
              <ListChecks strokeWidth={1}  size={20}    color="#fff"/>  <div style={{padding:"5px",fontSize:"12px",color:"#fff"}}> 5  Milestones</div>
                </div><div className="" style={{padding:"5px",display:"flex",justifyContent:"flex-start"}}> 
              <BellElectric strokeWidth={1}  size={20}    color="#fff"/>  <div style={{padding:"5px",fontSize:"12px",color:"#fff"}}> 5  Sections</div>
                </div><div className="" style={{padding:"5px",display:"flex",justifyContent:"flex-start"}}> 
              <ImagePlay strokeWidth={1}  size={20}    color="#fff"/>  <div style={{padding:"5px",fontSize:"12px",color:"#fff"}}> 5  Chapters</div>
                </div>
        </div>
            </div>
            <h3 align="center">{flattenedData?.length?"Showing " 
             +(flattenedData?.length):"Add A New "} {activeFilterTwo?flattenedData?.length>1?" Milestones"
             :" Milestone":activeFilterThree?" Deleted Milestones":""}  in Sub-course {SubCourseData?.menuOrder} for A Course - " {courseData?.CourseName} "
              
              </h3>
            <div  align="left" className=" " style={{margin:"5px",position:"relative",height:"110px"}}> 
          
  <HorizontalScroller items={flattenedData} />
            
            
            </div>
            {!createNewMileStoneStatus?flattenedData?.length? <div>    
              <SectionFolderPanel mileStoneItemSend={mileStoneItem} mileStoneSectionSend={mileStoneSection} setOpenMilestoneForSubCourse={setOpenMilestoneForSubCourse} selectCoursePopUp={selectCoursePopUp} SubCourseData={SubCourseData} />
            </div>:"":""}
            </div>




              {openAppDesignPopUp?<div className="appDesignPopUp"  style={{zIndex:99999} }>
   <div   onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} style={{cursor:"pointer",}} onClick={()=>{setopenAppDesignPopUp()}} 
            className="appDesignPopUpOpacity"></div>
   <div   className="appDesignPopUpInner " style={{margin:'0px',
    overflowY: "auto",zIndex:9999999,background:"#f9f9f9"}}>
         
        <div className="userInfoLiner" style={{background:"#ffffff"}} >
        <div className="userInfoLinerInn" style={{background:"#ffffff"}}>
        
          <img  className="userInfoLinerPic"src={user?.profile_pic?user?.profile_pic:"https://img.freepik.com/free-vector/illustration-businessman_53876-5856.jpg"} alt={user?.profile_pic} />
           
      </div>  
      </div><div className="userInfoLinerName">
              {openAppDesignPopUpInnerContent=="createMileStone"?
         <CreateMileStonePopup subCourseItem={SubCourseData} menuOrder={flattenedData?.length+1} sendBackItem={(subCourse)=>{sendBackItem(subCourse)}} changeItemData={(id,data)=>{updateItemData(id,data)} }  mileStoneItem={mileStoneItem} setopenAppDesignPopUp={setopenAppDesignPopUp} /> 
      :""}</div>
      </div>
      </div>:""}
      
    


        
        </div></>)
}
export default MilestonePanel;

